/**
 * Created by niko on 1/1/16.
 */

'use strict';

const BaseStore = require('fluxible/addons/BaseStore');
const SocialNetworks = require('bunsen/collections/identity/SocialNetworks');

class SocialNetworkStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);

        this._collection = new SocialNetworks();
    }

    _onSocialNetworksFetch(payload) {
        this._collection.reset(payload);
        this.emitChange();
    }

    getCollection() {
        return this._collection;
    }

    getSocialNetworks() {
        return this._collection.toJSON();
    }

    getSocialNetwork(name) {
        const socialNetwork = this._collection.findWhere({name});
        if (socialNetwork) {
            return socialNetwork.toJSON();
        } else {
            return null;
        }
    }

}

SocialNetworkStore.storeName = 'SocialNetworkStore';

SocialNetworkStore.handlers = {
    'socialNetworks:fetch': '_onSocialNetworksFetch'
};

module.exports = SocialNetworkStore;



// WEBPACK FOOTER //
// ./assets/js/global/stores/SocialNetworkStore.es.js